<template>
  <div id="pdfDom" class="pre-diacreport">
    <header class="dia-border grey ">
      <div class="u-flex u-row-between " style="margin-bottom:20px">
        <div class="title-left u-flex">
          <div class="head-title-lable">报告名称</div>
        </div>
        <div class="u-flex">
          <Button style="margin-right:8px" @click="toGetPdf(0)">下载</Button>
            <Button style="margin-right:8px" @click="toGetPdf(1, 0)">上传</Button>
        </div>
      </div>

      <div class="dia-specific">
        <div class="specific-left">
          <!-- <img src="@/assets/images/equ01.jpg" /> -->
        </div>
        <div class="specific-right mw">
          <div class="spcific-right-font u-flex">
            <div class="yu-suc"></div>
            <div>润滑点名称</div>
          </div>
          <div class="diasp-inputs">

            <div class="diasp-input u-flex" v-for="(index,key) in sextends[0].arr" :key="key">
              <div class="diasp-input-left line-1">
                {{index.label}}：
              </div>
              <div class="right-input line-1">
                {{index.value}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="dia-line"></div>
    <template v-for="(item,key) in sextends ">
      <template v-if="item.type=='char'">
        <div :key="key">
          <div>
            <div class="con-title" style="margin-bottom:20px">曲线</div>
            <div class="con-chart" :id="item.id">
            </div>
          </div>
          <div class="dia-line"></div>
        </div>
      </template>
      <template v-else-if="item.type=='text'">
        <div :key="key">
          <div>
            <div class="con-title">{{item.title}}</div>
            <div class="con-text-config" v-html="item.text">
           
            </div>
          </div>
          <div class="dia-line"></div>
        </div>
      </template>
      <template v-else-if="item.type=='table'">
        <div :key="key">
          <div>
            <div class="con-title">{{item.title}}</div>
            <div class="mt20">
              <Table :columns="columns1" :data="item.table" />
            </div>
          </div>
          <div class="dia-line"></div>
        </div>
      </template>
    </template>
    <!-- <template>
      <div>
        <div class="con-title">曲线</div>
        <div class="con-chart" id="con-chart">
        </div>
      </div>
      <div class="dia-line"></div>
    </template>
    
    <template>
      <div>
        <div class="con-title">文本1</div>
        <div class="con-text-config">
          这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里
          输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内容这里输入文本内
        </div>
      </div>
          <div class="dia-line"></div>
    </template>

    <template>
      <div>
        <div class="con-title">报警1</div>
        <div class="mt20">
          <Table :columns="columns1" :data="data1" />
        </div>
      </div>
       <div class="dia-line"></div>
    </template> -->
  </div>

</template>
<script>
  import * as Echarts from "echarts";
  import stroe2 from 'store2'
  import DiaCurve from './DiaCurve'
  import QullText from './QullText'
  import DiaTable from './DiaTable'
  import DiaportDraw from './diaticreport-draw.vue'
  import moment from 'moment'
  export default {
    name: "previewDiact",
    props: ['sextends'],
    components: {
      DiaCurve,
      QullText,
      DiaTable,
      DiaportDraw
    },
    data() {
      return {
        columns1: [],
        value: "",
        inputlist: [{
          label: "",
          value: ""
        }],

        diatice: null,
        buttontext: ['插入曲线', '插入文本', '插入报警'],

        body: {
          name: "",
          id: "",
          detail: {
            baseinfo: "",
            extends: []
          }
        },

      }
    },
    watch: {
      sextends: {
        deep: true,
        immediate: true,
        handler: function(array) {
       
          let arr = array.filter(e => e.type == 'char')
        
          this.$nextTick(() => {
            arr.forEach(item => {
              this.setchart(item.id, item.option)
            })
          })

        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      toGetPdf(val = false, download = true) {
        /**
     * val 决定走不走上传接口，默认为不上传给后端
     * download 默认是下载
     * /
 
      /* */
        this.$nextTick(() => {
      
          setTimeout(() => {
         
            window.scrollTo(0, 0); //这行代码很重要，它让页面的滚动条跳到了最上方如果点击打印按钮的时候,滚动条没有在最上方,打印内容会是不完整的,体验也会差
            let title = "个人报告"
       
            this.getPdf(title, download) //download：false为不下载，这里调用了刚刚引用的全局函数，.then得到的值是base64位的pdf文件
              .then((res) => {
               
                if (val) {
                 
                  this.UploadPdf(res);
                } else {
                  
                }
              });
          }, 1000);
        });
      },
      UploadPdf(res) {
        //res拿到base64的pdf
        let pdfBase64Str = res;
        let title = "上传给后端的个人报告"
        var myfile = this.dataURLtoFile(pdfBase64Str, title + ".pdf"); //调用一下下面的转文件流函数
        var formdata = new FormData();
        formdata.append("file", myfile); // 文件对象
        //该uploadMy为接口，直接以formdata格式传给后台
  
        this.$api.asxUpFile("post", `/ocm-oil-site/diagnostic-report/upload?id=1632602837663268866`, formdata).then((data)=>{
     
        })
      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
          type: mime
        });
      },
      inputAdd() {
        if (this.inputlist.length == 19) return
        this.inputlist.push({
          label: "",
          value: ""
        })
      },
      timeChange(times) {
        times = times / 1000
        let d = moment.duration(+times, "seconds");
        return Math.floor(d.asDays()) +
          "天" +
          d.hours() +
          "时" +
          d.minutes() +
          "分" +
          d.seconds() +
          "秒"
        return this.formatSeconds(times / 1000)

      },
      setchart(id = "con-chart", coption) {
        let myChart = Echarts.init(
          document.getElementById(id),
          "light"
        );
        let option = {
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          grid: {
            top: "10%",
            left: '3%',
            right: "0%",
            bottom: "10%",
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
          }]
        };
        if (coption) {
          option = coption
        }
        myChart.setOption(option, true);
      },
      async init() {



        this.columns1 = [{
            title: '序号',
            type: 'index',
            align: 'left',
            width: 70,
          },
          {
            title: '设备名称',
            key: 'deviceName',
            align: 'left',
            width: 180,
            render: (h, params) => {
              const item = params.row;
              return h("div", item.deviceName || "-");
            },
          },
          {
            title: '润滑点名称',
            key: 'name',
            width: 220,
            align: 'left',
            // sortable: true,
            // ellipsis: true,

            render: (h, params) => {

              return h('div', params.row.name || "-")
            }
          },
          {
            title: "报警指标",
            align: 'left',
            key: "identifierName",
            align: 'left',
            width: "100",
            render: (h, params) => {
              const item = params.row;
              return h("div", item.identifierName || "-");
            },
          },
          {
            title: "报警描述",
            key: "describe",
            align: 'left',
            width: "300",
            render: (h, params) => {
              const desc = params.row.describe;
              let desc250 = "";
              if (desc && desc.length > 250)
                desc250 = desc.substring(0, 250) + "...";
              else desc250 = desc || "-";
              return h("div", desc250);
            },
          },
          {
            title: "报警开始时间",
            key: "alarmStartTime",
            width: "180",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmStartTime || "-");
            },
          },
          {
            title: "报警结束时间",
            key: "alarmEndTime",
            width: "180",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmEndTime || "-");
            },
          },
          {
            title: "报警持续时间",
            key: "alarmDuration",
            width: "150",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h(
                "div",
                this.timeChange(item.alarmDuration)
                // (item.alarmDuration &&
                //     (item.alarmDuration / 60 / 60 / 1000).toFixed(
                //         2
                //     ) + " 小时") ||
                //     "-"
              );
            },
          },
          {
            title: "操作",
            key: "address",
            align: 'left',

            align: 'left',
            className: "action",
            render: (h, params) => {
              const index = params.indedx;
              return h("div", [
                h(
                  "span", {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.data1.splice(index, 1)

                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ]
      }
    }
  }
</script>

<style lang="less">
  .dia-border {
    width: 100%;
    padding: 16px 16px 35px 16px;
  }

  .pre-diacreport {
    .grey {
      // background: #FBFBFB;
    }

    .head-title-lable {
      font-size: 24px;

      font-weight: 400;
      color: #000000;
    }

    .dia-line {
      width: 100%;
      height: 1px;
      opacity: 0.1;
      background: #707070;
      margin: 18px 0;
    }

    header {

      .dia-specific {
        display: flex;

        .specific-left {
          flex: 0 0 340px;
          height: 241px;
          margin-right: 17px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .specific-right {
          padding-top: 16px;

          .spcific-right-font {
            font-size: 24px;
            line-height: 1;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.851);

            .yu-suc {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              margin-right: 8px;
            }
          }

          .diasp-inputs {
            width: 100%;
            height: 173px;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            margin-top: 16px;



            .diasp-input {
              width: 25%;
              margin-bottom: 8px;

              .diasp-input-left {
                width: 60px;
                height: 17px;
                font-size: 12px;
               
                font-weight: 400;
                color: rgba(0, 0, 0, 0.851);

                .left-lable {
                  margin-right: 16px;
                }

                input {
                  width: 100%;
                  height: 100%;
                  border: none;
                  text-align: center;
                }
              }

              .right-input {
                width: 204px;


              }

            }


          }
        }
      }
    }
  }

  .button-diasp-add {
    width: 93px !important;
    margin-right: 12px;
  }

  .diasp-add {
    width: 22%;
    height: 32px;
    border: 1px solid #DEDEDE;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: normal;
    color: #888888;
  }

  .dict-bottom {
    width: 100%;
    height: 144px;
    background: #FBFBFB;
    display: flex;
    align-items: center;
    justify-content: center;

    .dict-btn {
      padding: 6px 16px;
      height: 32px;
      border: 1px solid #DDDDDD;
    }
  }
</style>
<style>
  .olisname {
    border: 1px solid red !important;
  }

  .con-title {
    font-size: 24px;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
  }

  .con-chart {
    width: 100%;
    height: 314px;
  }

  .con-text-config {
    width: 100%;
    border: 1px solid #EAEAEA;
    padding: 8px 16px;
    margin-top: 20px;

  }

  .mt20 {
    margin-top: 20px;
  }
</style>